// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--owp5MwYjQgE123mR"};